// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import toast from './components/toast/index'
import { normalizeMemberInfo } from './utils/memberStatus'
Vue.use(ElementUI, { size: 'medium' })
Vue.prototype.$toast = toast

Vue.config.productionTip = false
Vue.prototype.$ajax = axios
axios.interceptors.request.use(
  config => {
    // 从 vuex 里拿 token
    const token = sessionStorage.getItem('token')
    // const token = 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI1NjYzNzY5ODIwMTI0OTc5MjAiLCJ1c2VybmFtZSI6Im9ocmptMjV1eHh2V21LeDBQT2NhODRGSzhEVlkiLCJyb2xlQ29kZSI6IlVTRVIiLCJpYXQiOjE3ODAwNzQwNTcsImV4cCI6MTc4MDY3ODg1N30.PDAD1AJX6zCYS0Ku7QbYbAAeeC4YZWzruBXNNiaL6JU'

    // 如果有 token，就加到请求头里
    if (token) {
      // config.headers['token'] = token  
      // 后端如果叫 Authorization 就改成：
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  response => {
    const res = response.data
    // 如果后端返回 code == 403
    if (res.code === 403) {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('userInfo')
    }
    if(res.code == 20000){
      const userInfo = normalizeMemberInfo(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))
      if (userInfo.memberType === 'PERSONAL') {
        toast.error('个人用户暂不开放项目供需')
        router.push('/activity')
      } else {
        toast.error('无权限，请先加入联盟')
        router.push('/apply/first')
      }
    }
    if(res.code != 200){
      toast.error(res.message)
    }

    return response
  },
  error => Promise.reject(error)
)
import 'amfe-flexible'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js